import { render, staticRenderFns } from "./AcceptRentForm.vue?vue&type=template&id=cbb89976&scoped=true&"
import script from "./AcceptRentForm.vue?vue&type=script&lang=js&"
export * from "./AcceptRentForm.vue?vue&type=script&lang=js&"
import style0 from "./AcceptRentForm.vue?vue&type=style&index=0&id=cbb89976&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbb89976",
  null
  
)

export default component.exports